import script from "./ffswiper2.vue?vue&type=script&setup=true&lang=js"
export * from "./ffswiper2.vue?vue&type=script&setup=true&lang=js"

import "./ffswiper2.vue?vue&type=style&index=0&id=34e1ce09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e1ce09"]])

export default __exports__